<template>
  <div class="toggle-switch" :class="`toggle-switch--${labelPosition}`">
    <span v-if="labelPosition === 'left'" class="toggle-switch__label">
      {{ label }}
    </span>

    <button
      type="button"
      class="toggle-switch__control"
      :class="{ 'is-active': value, 'is-disabled': disabled }"
      :disabled="disabled"
      @click="toggle"
    >
      <span class="toggle-switch__thumb"></span>
    </button>

    <span v-if="labelPosition === 'right'" class="toggle-switch__label">
      {{ label }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ToggleSwitch",

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: "",
    },

    labelPosition: {
      type: String,
      default: "right",
      validator: (value) => ["left", "right"].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    toggle() {
      this.$emit("change", !this.value);
    },
  },
};
</script>

<style scoped>
.toggle-switch {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.toggle-switch__label {
  font-size: 16px;
  color: #4b5563;
}

.toggle-switch__control {
  position: relative;
  width: 40px;
  height: 22px;
  border: none;
  border-radius: 999px;
  background: #bdbdbd;
  cursor: pointer;
  transition: all 0.25s ease;
  padding: 0;
}

.toggle-switch__thumb {
  position: absolute;
  top: 3px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  transition: all 0.25s ease;
}

.toggle-switch__control.is-active {
  background: #3098f7;
}

.toggle-switch__control.is-active .toggle-switch__thumb {
  transform: translateX(20px);
}

.toggle-switch__control.is-disabled {
  background: #565F77;
  cursor: not-allowed;
}

button:focus {
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Input/ToggleSwitch.vue